class WishWeekFromSixToTwelve extends WishWeek{
    constructor(numberOfIntervals, weekNumber, ignoreAOnPublicHoliday){
        super(numberOfIntervals, weekNumber, ignoreAOnPublicHoliday);
    }
    setDays(){
        let weekdays = ["mo", "di", "mi", "do", "fr", "sa", "so"];
        for(let i = 0; i < weekdays.length; i++) {
            let feiertag = !isACountedOnDay(document.getElementById("w" + this.weekNumber + "_tagname" + (i+1)).innerHTML, this.ignoreAOnPublicHoliday); //boolean get toggled
            this.wishDays[i]= new WishDay(feiertag, weekdays[i]);
            if(this.numberOfIntervals == 96){
                for (let j = 0; j < this.NUMBER_OF_NEW_INTERVALS; j++) {
                    if(j >= 24){ //intervalle vor 6 Uhr werden leer gefüllt
                        this.wishDays[i].setInterval(j, document.getElementById("w" + this.weekNumber + "_" + weekdays[i] + (j-24)).value);
                        if (this.numberOfIntervals != this.NUMBER_OF_NEW_INTERVALS) {
                            this.wishDays[i].setInterval((j+1), document.getElementById("w" + this.weekNumber + "_" + weekdays[i] + (j-23)).value);
                        }
                    }else{
                        this.wishDays[i].setInterval(j, "");
                        if (this.numberOfIntervals != this.NUMBER_OF_NEW_INTERVALS) {
                            this.wishDays[i].setInterval((j+1), "");
                        }
                    }
                }
            }
            else if(this.numberOfIntervals == 48){
                for (let j = 0; j < this.NUMBER_OF_NEW_INTERVALS/2; j++) {
                    if(j >= 12){ //intervalle vor 6 Uhr werden leer gefüllt
                        this.wishDays[i].setInterval(j, document.getElementById("w" + this.weekNumber + "_" + weekdays[i] + (j-12)).value);
                        if (this.numberOfIntervals != this.NUMBER_OF_NEW_INTERVALS/2) {
                            this.wishDays[i].setInterval((j+1), document.getElementById("w" + this.weekNumber + "_" + weekdays[i] + (j-11)).value);
                        }
                    }else{
                        this.wishDays[i].setInterval(j, "");
                        if (this.numberOfIntervals != this.NUMBER_OF_NEW_INTERVALS/2) {
                            this.wishDays[i].setInterval((j+1), "");
                        }
                    }
                }
            }
        }
    }
    isAOnDaysBeforeTime(day, timeIntervall){
        return super.isAOnDaysBeforeTime(day, timeIntervall);
    }
    isAOnDaysAfterTime(day, timeIntervall) {
        return super.isAOnDaysAfterTime(day, timeIntervall);
    }
    isPublicHoliday(dayOfWeek) {
        return super.isPublicHoliday(dayOfWeek);
    }
}